export default "__VITE_ASSET__CkBwjS6A__"